import { useOnClickEscape } from './useOnClickEscape';
import { useOnClickOutside } from './useOnClickOutside';

function useOnDismiss(target, active, callback) {
    useOnClickEscape(active, callback);
    useOnClickOutside(target, active, callback);
}

export { useOnDismiss };
